import styled, { css } from 'styled-components';

export const Container = styled.ul`
  position: relative;
  min-height: fit-content;
  background: #ffffff;
  border-radius: 4px;

  padding: 1.9rem 2.3rem;
`;

export const Options = styled.div`
  position: absolute;
  right: 3%;
  top: 5%;

  cursor: pointer;

  > svg {
    &:hover {
      background: #dadada;
      border-radius: 50%;
    }
  }

  > div {
    display: flex;
    justify-content: center;
    flex-direction: column;

    position: absolute;
    left: -10rem;
    overflow: hidden;

    width: 14rem;

    background: #ffffff;

    box-shadow: 0px 0px 4px #40404030;
    border-radius: 2px;

    opacity: 0;

    transition: 300ms ease-in-out;
    pointer-events: none;

    .divider {
      height: 1px;
      background: #cbcbcb;
      margin: 0 0.3rem;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;

      background: #ffffff;
      height: 4rem;
      border-radius: 0;

      color: #0f0f0f;
      font-size: 1.4rem;
      font-family: ${({ theme }) => theme.fontFamily.Nunito};
      font-weight: 600;
      line-height: 1.9rem;

      &:hover {
        background: #40404030;
      }
    }
  }

  &:hover {
    > div {
      opacity: 1;
      pointer-events: visible;
    }
  }
`;

export const CardContainer = styled.div``;

export const BillingNumber = styled.h2`
  font-size: 1.8rem;
  font-weight: bold;
  text-align: center;
`;

export const BillingTrainingAmount = styled.h2`
  font-size: 1.5rem;
  text-align: center;
`;

export const ProgramContainer = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
  margin-top: 2rem;
  flex-wrap: wrap;

  ul {
    width: 100%;
  }
`;

export const Program = styled.li`
  min-height: 7rem;
  background: #f3f3f3;
  border: 1px solid #d8d8d850;
  border-radius: 4px;
  margin-bottom: 2rem;

  padding: 1.1rem 0;

  display: flex;
  flex-direction: column;
  align-items: center;

  cursor: pointer;

  @media (max-width: 425px) {
    width: 100%;
  }
`;

export const ProgramContent = styled.span`
  font-size: 1.5rem;
  margin-bottom: 0.5rem;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
`;

export const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

type ButtonProps = {
  secondary?: boolean;
};

export const ButtonContainer = styled.button<ButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;
  font-size: 2.2rem;

  width: 46.4rem;
  height: 5.8rem;

  background: transparent linear-gradient(96deg, #ffd503 0%, #ffdf22 100%);

  border-radius: 5rem;

  transition: 180ms ease-in;

  margin-bottom: 2.5rem;

  @media (max-width: 425px) {
    width: 30.4rem;
  }

  ${(props) =>
    props.secondary &&
    css`
      background: transparent linear-gradient(96deg, #000000 0%, #232323 100%);
    `}

  &:hover {
    opacity: 0.85;
  }
`;

export const ButtonText = styled.p<ButtonProps>`
  font-weight: bold;
  font-size: 2.4rem;
  color: #000;

  ${(props) =>
    props.secondary &&
    css`
      color: #ffffff;
    `}
`;
